const loginTestIDs = {
  loginLogo: 'login-logo',
  loginBanner: 'login-banner',
  loginUsernameInput: 'login-username-input',
  loginPasswordInput: 'login-password-input',
  loginErrorMessage: 'login-error-message',
  loginEmailErrorMessage: 'login-email-error-message',
  loginLoginButton: 'login-login-button',
  loginSetupBiometricsLabel: 'login-biometrics-checkbox-label',
  loginSetupBiometricsCheckbox: 'login-biometrics-checkbox',
  loginForgotPasswordButton: 'login-forgot-password-button',
  loginPinButton: 'login-pin-button',
  loginFaceIdButton: 'login-face-id-button',
  loginTermsLink: 'login-terms-link',
  loginPrivacyPolicyLink: 'login-privacy-policy-link',

  loginModal: 'login-modal',
  loginModalHeader: 'login-modal-header',
  loginModalBody: 'login-modal-body',
  loginModalStayHere: 'login-modal-stay-here',
  loginModalGoToSite: 'login-modal-go-to-site',

  forgotPasswordModal: 'forgot-password-modal',
  forgotPasswordModalHeader: 'forgot-password-modal-header',
  forgotPasswordModalCloseBtn: 'forgot-password-modal-close-button',
  forgotPasswordModalCloseButton: 'forgot-password-modal-close-button',
  forgotPasswordModalDescription: 'forgot-password-modal-description',
  forgotPasswordModalEmailLabel: 'forgot-password-modal-email-label',
  forgotPasswordModalEmailInput: 'forgot-password-modal-email-value',
  forgotPasswordModalError: 'forgot-password-modal-error',
  forgotPasswordModalResetBtn: 'forgot-password-modal-reset-button',
  resetEmailSentMessage: 'reset-email-sent-label',
  resetEmailSentCloseButton: 'reset-email-sent-close-button',
};

export default loginTestIDs;
